import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Notification02Icon } from "@/components/ui/Icons";
import { useNavigate } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

export function MobileHeader({ onMenuClick, role, userName, userInitial, hasUnreadNotifications = false }) {
  const navigate = useNavigate();
  return (
    <header className="md:hidden fixed top-0 left-0 w-full h-[56px] z-50 flex items-center justify-between px-4 bg-sidebar/90 backdrop-blur-md border-b border-sidebar-border shadow-sm">
      <div className="flex items-center gap-3">
        {/* Touch target 44x44 constraint */}
        <Button variant="ghost" size="icon" onClick={onMenuClick} className="min-h-[44px] min-w-[44px]">
          <Menu className="h-5 w-5" />
        </Button>
      </div>
      
      <div className="flex-1 flex justify-center items-center h-full">
         <BrandLogo alt="Institute logo" className="h-8 object-contain" />
      </div>
      
      <div className="flex items-center gap-1">
        <Button 
          variant="ghost" 
          size="icon" 
          className="relative min-h-[44px] min-w-[44px]" 
          onClick={() => navigate(`/${role}/notifications`)}
        >
          <Notification02Icon className="h-5 w-5" />
          {hasUnreadNotifications ? (
            <span className="absolute top-2.5 right-2.5 w-2 h-2 bg-destructive rounded-full" />
          ) : null}
        </Button>
        <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-primary text-sm font-semibold ml-1 shrink-0">
          {userInitial}
        </div>
      </div>
    </header>
  );
}
